module.exports = __webpack_public_path__ + "img/dbf.f18cf4e5.svg";